import { gql } from '@apollo/client';

export const GET_PATIENT_EXAMS = gql`
  query PatientExams($examsFilter: FilterFindManyReducedExamInput!) {
    examsByPatient(filter: $examsFilter, sort: CREATED_AT_DESC) {
      _id
      examDate
      relevantFindingsCount
      technology
      priority
      user {
        firstName
        lastName
      }
      detectionsCount
      status
    }
  }
`;
